import { Route } from "react-router-dom";
import { Routes } from "react-router-dom";
import SelectGame from "./select-game/SelectGame";
import JigsawGame from "./jigsaw-game/JigsawGame";
import EliminateGame from "./eliminate-game/EliminateGame";
import BubblesGame from "./bubbles-game/BubblesGame";
import ScratchGame from "./scratch-game/ScratchGame";
import WhackGame from "./whack-game/WhackGame";

function NewGameManage() {
  return (
    <Routes>
      <Route element={<SelectGame />} path="selectGame" />
      <Route element={<JigsawGame />} path="jigsawGame" />
      <Route element={<EliminateGame />} path="eliminateGame" />
      <Route element={<BubblesGame />} path="bubblesGame" />
      <Route element={<ScratchGame />} path="scratchGame" />
      <Route element={<WhackGame />} path="whackGame" />
    </Routes>
  );
}

export default NewGameManage;
